import { useMemo } from 'react';
import { usePageLayoutResize } from '@atlassian/jira-navigation-system/src/index.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createHook } from '@atlassian/react-sweet-state';
import type { LeftSidebarState } from '../../../../common/types.tsx';
import { layoutStore } from '../../store/index.tsx';

const useSweetStateLeftSidebarState = createHook(layoutStore, {
	selector: (state) => ({
		...state.content.leftSidebar,
		shouldRender: !state.isChromeless,
	}),
});

type ExtenedLeftSidebarState = LeftSidebarState & {
	shouldRender: boolean;
};

export const useLeftSidebarState = (): ExtenedLeftSidebarState => {
	const [leftSidebar] = useSweetStateLeftSidebarState();
	return leftSidebar;
};

export const useLeftSidebarController = () => {
	const { expandLeftSidebar, collapseLeftSidebar } = usePageLayoutResize();
	return useMemo(
		() => ({
			collapseLeftSidebar,
			expandLeftSidebar,
		}),
		[collapseLeftSidebar, expandLeftSidebar],
	);
};
